import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { NetworkAppContainerDataProviderFactory } from '../factory/NetworkAppContainerDataProviderFactory';
import { NetworkAppContainerConsoleDataProvider } from '../dataProvider/NetworkAppContainerConsoleDataProvider';
import { InitNetworkResponse } from '../helpers/types';

export class NetworkAppContainerRepository extends BaseWebComponentRepository {
  public dataProviderFactory: NetworkAppContainerDataProviderFactory;
  public dataProvider: NetworkAppContainerConsoleDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new NetworkAppContainerDataProviderFactory(),
    });
  }

  async computeUserConfig(): Promise<InitNetworkResponse> {
    return await this.dataProvider.computeUserConfig();
  }
}
